import { theme, Image, Button, Typography, Spin } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminAppLayout from "../../../Layouts/AdminLayout";
import { useParams, useNavigate } from "react-router-dom";
import { GET_IMAGE_BY_ID } from "../../../../API/paths";
import logo from "../../../../../assets/logo.png";
import { isMobile } from "react-device-detect";
import { USER_TYPES } from "../../../../Constants/ApplicationConstants";
import { colors } from "../../../utils/colors";
import { RoutesLookup } from "../../../../Routes/RoutesLookup";
import { BASE_URL } from "../../../../Constants/EnvironmentVariableProvider";
const { Title } = Typography;

const ViewImagePreview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [imageData, setImageData] = useState(null);

  const getImageById = async () => {
    try {
      const response = await axios.get(`${BASE_URL}${GET_IMAGE_BY_ID}?Id=${id}`);
      setImageData(response?.data?.result);
    } catch (error) {
      console.error("Failed to fetch image details", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getImageById();
    // eslint-disable-next-line
  }, [id]);

  // Mimic login page styling
  const { token } = theme.useToken();
  const colorBgLoginLayout = token["colorBgLoginLayout"];
  // For preview, assume the user is an agent so that the title is identical to the user-facing page.
  const userType = USER_TYPES.AGENT;

  return (
    <AdminAppLayout>
      <Spin spinning={loading}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            verticalAlign: "middle",
            alignItems: "center",
          }}
        >
          {/* Left Panel: Preview Image and Text */}
          <div
            style={{
              background: colorBgLoginLayout,
              width: "55%",
              height: "100vh",
              justifyContent: "center",
              alignItems: "center",
              display: isMobile ? "none" : "flex",
            }}
          >
            <div>
              <Image
                style={{ height: 400 }}
                preview={false}
                src={imageData ? imageData.GLIM_Image_Path : ""}
              />
              <Title
                style={{ textAlign: "center", color: colors.black, fontSize: 30 }}
              >
                Woohoo!
              </Title>
              <Title
                level={4}
                style={{ textAlign: "center", color: colors.black, margin: 0 }}
              >
                You have points...
              </Title>
              <Title
                level={4}
                style={{ textAlign: "center", color: colors.black, margin: 0 }}
              >
                Go pick your prize!
              </Title>
            </div>
          </div>
          {/* Right Panel: Logo, Title, and Back Button */}
          <div
            style={{
              width: isMobile ? "100%" : "45%",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: 350 }}>
              <div
                style={{ textAlign: "center", position: "relative", top: -30 }}
              >
                <Image
                  src={logo}
                  preview={false}
                  style={{ marginBottom: 20, objectFit: "cover" }}
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <Title
                  level={3}
                  style={{
                    marginBottom: 15,
                    marginTop: 0,
                    color: colors.grey900,
                    textAlign: "center",
                  }}
                >
                  Welcome to Normandy Loyalty Rewards{" "}
                  {userType === USER_TYPES.ADMIN ? "Admin Portal" : ""}
                </Title>
              </div>
              <Button block type="primary" onClick={() => navigate(RoutesLookup.SETTINGS)}>
                Back
              </Button>
            </div>
          </div>
        </div>
      </Spin>
    </AdminAppLayout>
  );
};

export default ViewImagePreview;